import * as actionTypes from '../constants/reducer'

export const setReducer=(obj)=>async dispatch=>{
    dispatch({
        type:actionTypes.SET_REDUCER,
        payload:obj
    })
}